import { ISortable } from "../../interfaces/i-sortable.interface";

export class Sample implements ISortable {  
  public id: number;
  public requestId: number;
  public name: string;
  public sortIndex: number;
}
